import React from 'react';
// import './MovingLine.css';
import WorkoutImg1 from '../../assets/workout-1.jpg';
import WorkoutImg2 from '../../assets/workout-2.png';
import WorkoutImg3 from '../../assets/workout-3.jpg';
import WorkoutImg4 from '../../assets/workout-4.jpg';
import WorkoutImg5 from '../../assets/workout-5.gif';
import WorkoutImg6 from '../../assets/workout-6.webp';
import WorkoutImg7 from '../../assets/workout-7.jpg';
import WorkoutImg8 from '../../assets/workout-8.gif';
import WorkoutImg9 from '../../assets/workout-9.gif';
import WorkoutImg10 from '../../assets/workout-10.gif';
import WorkoutImg11 from '../../assets/workout-11.gif';
import WorkoutImg12 from '../../assets/workout-12.gif';
import WorkoutImg13 from '../../assets/workout-13.gif';
import WorkoutImg14 from '../../assets/workout-14.webp';
import WorkoutImg15 from '../../assets/workout-15.gif';
import WorkoutImg16 from '../../assets/workout-16.gif';
import WorkoutImg17 from '../../assets/workout-17.gif';
import WorkoutImg18 from '../../assets/workout-18.jpg';
import WorkoutImg19 from '../../assets/workout-19.gif';
import WorkoutImg20 from '../../assets/workout-20.gif';



function MovingLine() {

return (
    <div className="moving-line">
        <div className="image-container">
            <img
                src={WorkoutImg1}
                alt={`Image ${  1}`}
                className="moving-image"/>
            <img
                src={WorkoutImg2}
                alt={`Image ${ 2}`}
                className="moving-image"/>
            <img
                src={WorkoutImg3}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg4}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg5}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg6}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg7}
                alt={`Image ${7}`}
                className="moving-image"/>
            <img
                src={WorkoutImg8}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg9}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg10}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg11}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg12}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg13}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg14}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg15}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg16}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg17}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg18}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg19}
                alt={`Image ${3}`}
                className="moving-image"/>
            <img
                src={WorkoutImg20}
                alt={`Image ${20}`}
                className="moving-image"/>
          
      </div>
    </div>
  );
}

export default MovingLine;
